module.exports = __webpack_public_path__ + "bg912-gray-0f2cb2d0c53041aeaa9cfe227c74efe2.jpg";